import { ApolloClient, NormalizedCacheObject, gql } from "@apollo/client";

// Store the active subscription so we can unsubscribe later
let deviceSubscription: any = null;

const ON_CREATE_DEVICE = gql`
  subscription OnCreationDevice {
    T26OnCreationDevice {
      id
    address
    comment
    deviceLocation {
        lat
        lon
    }
    isVerified
    paymentService
    registrationDate
    user {
        id
    }
    }
  }
`;

/**
 * Subscribe to new device creations and keep reference to unsubscribe
 */
export const subscribeOnCreateDevice = (client: ApolloClient<NormalizedCacheObject>) => {
    const observable = client.subscribe({ query: ON_CREATE_DEVICE });
    // Initiate the subscription and keep a reference
    deviceSubscription = observable.subscribe({});
    return observable;
};

/**
 * Unsubscribe from device creation subscription
 */
export const unsubscribeOnCreateDevice = () => {
    if (deviceSubscription) {
        deviceSubscription.unsubscribe();
        deviceSubscription = null;
    }
};
